<script>
import Modal from '../Modal.vue'
import axios from 'axios';
import RedactorControlVue from '../RedactorControl.vue';

export default {
    components: {
        Modal,
        RedactorControlVue
    },

    props: {
        jobApplications: {
            type: Array,
            required: true
        },
        phaseName: {
            type: String,
            default: ''
        },
        phase: {
            type: String,
            default: ''
        },
        csrfToken: {
            type: String,
            required: true
        },
    },

    data() {
        return {
            data: {},
        }
    },

    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        },
        pass() {
            try {
                axios.post(`/ajax/requisitions/bulk-pass`, {
                    jobApplications: this.jobApplications,
                    phase: this.phase,
                    data: this.data
                }, {
                headers: {
                    'X-CSRF-TOKEN': this.csrfToken
                }
                });
                window.location.href = '?'
            } catch (error) {

            }
        }
    },
}
</script>

<template>
    <modal ref="modal" :heading="`Pass Applicant/s on ${phaseName}`">
        <div class="grid-x grid-padding-x">
            <div class="cell shrink">
                Are you sure you want to pass the {{jobApplications.length}} selected applicants to the next phase?
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell col-12 text-left" v-if="phase==='loading_offer'">
                <strong>Onboarding Invitation</strong>
                <p>Invite candidate to an orboarding session. Please specify the details of the boarding session
                    below:</p>
                <br>
                <strong>Date & Time</strong>
                <input
                    type="datetime-local"
                    v-model="data.onboarding_datetime"
                    required
                />
                <br />
                <strong>Venue/ location</strong>
                <textarea
                    v-model="data.venue"
                    required
                ></textarea>
                <br />
                <strong>Google maps link </strong>
                <input
                    type="text"
                    v-model="data.google_maps_link"
                    required
                />
                <br />
                <strong>Contact Person</strong>
                <input
                    type="text"
                    v-model="data.contact_person"
                    required
                />
                <br />
                <strong>Contact Number</strong>
                <input
                    type="text"
                    v-model="data.contact_number"
                    required
                />
                <br />
                <strong>Other Notes</strong>
                <RedactorControlVue
                    v-model="data.notes"
                />
            </div>

            <div class="cell col-12 text-left" v-if="phase==='onboarding'">
                <br/>
                <strong>Did the candidate attend the onboarding session?</strong>
                <br>
                <div>Start Date</div>
                <input
                    type="datetime-local"
                    v-model="data.job_offer_start_date"
                    required
                />
                <br />
            </div>
        </div>
        <div class="grid-x grid-padding-x align-right">
            <div class="cell shrink">
                <div class="grid-x grid-padding-x align-right">
                    <div class="cell shrink">
                        <button class="button success" type="button" @click="pass">Pass</button>
                    </div>
                    <div class="cell shrink">
                        <button class="button warning" type="button" @click="toggleModal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<style scoped>
.checkbox-group {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
}
</style>